"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CommandsManager_1 = __importDefault(require("../general/CommandsManager"));
// TRICK to make tailwind css generate the classes
let colors = "bg-red-500 bg-orange-500 bg-yellow-500 bg-green-500 bg-blue-500 bg-indigo-500 bg-violet-500";
let colorsBorders = "border-red-500 border-orange-500 border-yellow-500 border-green-500 border-blue-500 border-indigo-500 border-violet-500";
class Pointers {
    constructor(element, myId, myName) {
        this.isPointersActive = false;
        this.PT = 500; // 500 ms
        this.mouseEvents = []; // this will hold all mouse events
        this.MINIMUM_LATENCY = 30;
        this.wait = false;
        this.eventsPerSecond = 60;
        this.pointers = {};
        this.pointersName = {};
        this.pointerTracker = 0;
        this.prevMoves = { x: -9999999, y: -9999999 };
        this.isMouseDown = false;
        this.laserTrail = [];
        this.drawings = [];
        this.pointersMap = {};
        this.myId = myId;
        this.myName = myName;
        this.mouseEvents;
        console.log("setup pointers");
        this.sendMouseEventsEveryXSeconds(this.PT);
        this.setupCommands();
        this.viewportEl = element;
        this.pointersWrapper = document.createElement('div');
        this.pointersWrapper.classList.add('pointers-wrapper');
        element.appendChild(this.pointersWrapper);
        this.myPointerEl = document.createElement('div');
        element.appendChild(this.myPointerEl);
        this.canvasEl = document.createElement('canvas');
        this.canvasEl.width = this.canvasEl.offsetWidth;
        this.canvasEl.height = this.canvasEl.offsetHeight;
        this.canvasEl.addEventListener("touchstart", (event) => {
            event.preventDefault();
            this.handleViewportOver(undefined, event);
            this.handleMove(undefined, event);
            this.isMouseDown = true;
            // start a new drawing
            this.drawings.push({ points: [], startedAt: Date.now() });
        });
        this.canvasEl.addEventListener("touchmove", (event) => {
            this.handleMove(undefined, event);
            event.preventDefault();
        });
        this.canvasEl.addEventListener("touchend", (event) => {
            this.handleViewportLeave();
            event.preventDefault();
            this.isMouseDown = false;
        });
        this.canvasEl.addEventListener("touchcancel", (event) => {
            event.preventDefault();
        });
        element.appendChild(this.canvasEl);
        // setup events
        element.addEventListener("mouseenter", this.handleViewportOver.bind(this));
        element.addEventListener("mouseleave", this.handleViewportLeave.bind(this));
        element.addEventListener("mousemove", this.handleMove.bind(this));
        element.addEventListener("mousedown", (e) => {
            this.isMouseDown = true;
            // start a new drawing
            this.drawings.push({ points: [], startedAt: Date.now() });
        });
        element.addEventListener("mouseup", () => { this.isMouseDown = false; });
        // draw the laser trail 
        this.canvasEl.width = this.canvasEl.offsetWidth;
        this.canvasEl.height = this.canvasEl.offsetHeight;
        window.addEventListener('resize', () => {
            this.canvasEl.width = this.canvasEl.offsetWidth;
            this.canvasEl.height = this.canvasEl.offsetHeight;
        });
        const ctx = this.canvasEl.getContext('2d');
        setInterval(() => {
            if (this.isPointersActive == false)
                return;
            ctx.clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
            this.drawings.forEach((d) => {
                this.drawDrawing(ctx, d);
            });
            // remove the drawings that are older than 3 seconds
            this.drawings = this.drawings.filter((d) => {
                return d.points.length > 0 || Date.now() - d.startedAt < 3000;
            });
            // iterate over the pointersMap and draw the drawings
            for (const [key, value] of Object.entries(this.pointersMap)) {
                value.forEach((d) => {
                    this.drawDrawing(ctx, d);
                });
            }
        }, 1000 / 60);
    }
    setupCommands() {
        CommandsManager_1.default.registerNewCommand('presenter--pointers_active', () => {
            this.enablePointers();
        });
        CommandsManager_1.default.registerNewCommand('presenter--pointers_inactive', () => {
            this.disablePointers();
        });
        CommandsManager_1.default.registerNewCommand('presenter--pointer_pos', async ({ args: { id, positions, drawings } }) => {
            if (this.isPointersActive == false)
                return;
            this.updatePointer(id, positions);
            await this.sleep(this.PT / 2);
            this.pointersMap[id] = drawings;
        });
        CommandsManager_1.default.registerNewCommand('presenter--pointer_delete', ({ args: { id } }) => {
            if (this.isPointersActive == false)
                return;
            this.deletePointer(id);
        });
        CommandsManager_1.default.registerNewCommand('presenter--pointer_add', ({ args: { id, pos, name } }) => {
            if (this.isPointersActive == false)
                return;
            this.addPointer(id, pos, name);
        });
    }
    enablePointers() {
        this.canvasEl.style.position = "absolute";
        this.canvasEl.style.top = "0";
        this.canvasEl.style.left = "0";
        this.canvasEl.style.width = "100%";
        this.canvasEl.style.height = "100%";
        this.canvasEl.style.zIndex = "41";
        this.canvasEl.width = this.canvasEl.offsetWidth;
        this.canvasEl.height = this.canvasEl.offsetHeight;
        this.pointersWrapper.style.position = "absolute";
        this.pointersWrapper.style.top = "0";
        this.pointersWrapper.style.left = "0";
        this.pointersWrapper.style.width = "100%";
        this.pointersWrapper.style.height = "100%";
        this.pointersWrapper.style.zIndex = "41";
        this.myPointerEl.style.position = "absolute";
        this.myPointerEl.style.top = "0";
        this.myPointerEl.style.left = "0";
        this.myPointerEl.style.width = "100%";
        this.myPointerEl.style.height = "100%";
        this.myPointerEl.style.zIndex = "41";
        this.myPointerEl.style.zIndex = "41";
        this.isPointersActive = true;
    }
    disablePointers() {
        this.isPointersActive = false;
        this.pointers = {};
        this.pointersName = {};
        this.pointerTracker = 0;
        // wait a bit for the pointers to disappear
        // this is because the painting function may run  slightly after
        // the pointers are disabled
        window.setTimeout(() => {
            this.pointersWrapper.innerHTML = "";
            this.myPointerEl.innerHTML = "";
        }, 1000);
        this.canvasEl.style.position = "absolute";
        this.canvasEl.style.top = "0";
        this.canvasEl.style.left = "0";
        this.canvasEl.style.width = "0%";
        this.canvasEl.style.height = "0%";
        this.canvasEl.style.zIndex = "1";
        this.pointersWrapper.style.position = "absolute";
        this.pointersWrapper.style.top = "0";
        this.pointersWrapper.style.left = "0";
        this.pointersWrapper.style.width = "0%";
        this.pointersWrapper.style.height = "0%";
        this.pointersWrapper.style.zIndex = "41";
        this.myPointerEl.style.position = "absolute";
        this.myPointerEl.style.top = "0";
        this.myPointerEl.style.left = "0";
        this.myPointerEl.style.width = "0%";
        this.myPointerEl.style.height = "0%";
        this.myPointerEl.style.zIndex = "41";
        this.myPointerEl.style.zIndex = "41";
    }
    drawMyPointer(x, y) {
        this.myPointerEl.innerHTML = "";
        let name = "Me";
        let utf8Encode = new TextEncoder();
        let colorIndex = utf8Encode.encode(this.myName).reduce((a, b) => a + b, 0) % 7;
        let colors = ["red", "orange", "yellow", "green", "blue", "indigo", "violet"];
        let color = colors[colorIndex];
        let template = `<div class="absolute" style="top: ${y}%; left:${x}%">
        <!-- Ring icon -->
          <div class="-ml-3 -mt-3 h-6 w-6  lg:-ml-5 lg:-mt-5 lg:h-10 lg:w-10 rounded-full bg-transparent border-4 lg:border-2 border-${color}-500 shadow-md"></div>
        <div class="bg-${color}-500 text-white px-1 text-xs">${name}</div>
      </div>`;
        this.myPointerEl.insertAdjacentHTML("beforeend", template);
    }
    drawDrawing(ctx, drawing) {
        const width = this.canvasEl.scrollWidth;
        const height = this.canvasEl.scrollHeight;
        ctx.strokeStyle = "red";
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        ctx.shadowColor = "red";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        if (drawing.points.length == 0)
            return;
        const last = drawing.points[drawing.points.length - 1];
        if (Date.now() - last.time > 1075 && Date.now() - last.time < 2500) {
            ctx.shadowBlur = 3;
        }
        else {
            ctx.shadowBlur = 0;
        }
        var lineWidth = 3;
        ctx.beginPath();
        for (var i = 0; i < drawing.points.length; i++) {
            const p = drawing.points[i];
            const oldP = drawing.points[i - 1];
            if (i == 0) {
                ctx.moveTo((p.x / 100 * width), (p.y / 100 * height));
            }
            else {
                ctx.beginPath();
                ctx.moveTo((oldP.x / 100 * width), (oldP.y / 100 * height));
                let colorIdx = Math.round(-(3 / 3000) * (Date.now() - p.time) + 3);
                ctx.fillStyle = ["red", "orange", "yellow", "green", "blue", "indigo", "violet"][5 - colorIdx];
                if (Date.now() - p.time > 1000 && Date.now() - p.time < 1025) {
                    ctx.strokeStyle = "rgb(255, 255, 255)";
                }
                else {
                    ctx.strokeStyle = ["#800B0B", "#B30F0F", "#E71414", "#EF4444"][5 - colorIdx];
                }
                ctx.lineWidth = -(lineWidth / 3000) * (Date.now() - p.time) + lineWidth;
                ctx.lineTo((p.x / 100 * width), (p.y / 100 * height));
                ctx.stroke();
            }
        }
        drawing.points = drawing.points.filter((p) => {
            return Date.now() - p.time < 3000;
        });
    }
    drawPointers() {
        this.pointersWrapper.innerHTML = "";
        for (const [key, value] of Object.entries(this.pointers)) {
            let name = this.pointersName[key];
            let utf8Encode = new TextEncoder();
            let colorIndex = utf8Encode.encode(name).reduce((a, b) => a + b, 0) % 7;
            let colors = ["red", "orange", "yellow", "green", "blue", "indigo", "violet"];
            let color = colors[colorIndex];
            let template = `<div class="absolute" style="top: ${value.y}%; left:${value.x}%">
        <!-- Ring icon -->
          <div class="-ml-3 -mt-3 h-6 w-6  lg:-ml-5 lg:-mt-5 lg:h-10 lg:w-10 rounded-full bg-transparent border-4 lg:border-2 border-${color}-500 shadow-md"></div>
        <div class="bg-${color}-500 text-white px-1 text-xs">${name}</div>
      </div>`;
            this.pointersWrapper.insertAdjacentHTML("beforeend", template);
        }
    }
    handleViewportOver(e, touch) {
        if (this.isPointersActive == false)
            return;
        const rect = this.viewportEl.getBoundingClientRect();
        // Half of the cursor size is the offset on average (pixel value) currentrly is h-2(8px)
        var cursorOffSet = 3;
        var x = 0;
        var y = 0;
        if (e) {
            x = (e.clientX - rect.left - cursorOffSet) / rect.width; //x position within the element.
            y = (e.clientY - rect.top - cursorOffSet) / rect.height; //y position within the element.
        }
        if (touch) {
            x = (touch.touches[0].clientX - rect.left - cursorOffSet) / rect.width; //x position within the element.
            y = (touch.touches[0].clientY - rect.top - cursorOffSet) / rect.height; //y position within the element.
        }
        var arg = { id: this.myId, pos: { x: x, y: y }, name: this.myName };
        CommandsManager_1.default.sendAllCommand('presenter--pointer_add', arg);
    }
    handleViewportLeave() {
        if (this.isPointersActive == false)
            return;
        CommandsManager_1.default.sendAllCommand('presenter--pointer_delete', { id: this.myId });
    }
    async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    handleMove(e, touch) {
        if (this.isPointersActive == false)
            return;
        const rect = this.viewportEl.getBoundingClientRect();
        // Half of the cursor size is the offset on average (pixel value) currentrly is h-2(8px)
        var cursorOffSet = 3;
        var x = 0;
        var y = 0;
        if (e) {
            x = (e.clientX - rect.left - cursorOffSet) / rect.width; //x position within the element.
            y = (e.clientY - rect.top - cursorOffSet) / rect.height; //y position within the element.
        }
        if (touch) {
            x = (touch.touches[0].clientX - rect.left - cursorOffSet) / rect.width; //x position within the element.
            y = (touch.touches[0].clientY - rect.top - cursorOffSet) / rect.height; //y position within the element.
        }
        if (this.isMouseDown == true) {
            if (this.drawings.length > 0) {
                let newPoint = { x: x * 100, y: y * 100, time: Date.now() };
                let currentDrawing = this.drawings[this.drawings.length - 1];
                if (currentDrawing.points.length > 0) {
                    let lastPoint = currentDrawing.points[currentDrawing.points.length - 1];
                    newPoint = getExponentialSmoothedPoint(lastPoint, newPoint, 0.5);
                    this.drawings[this.drawings.length - 1].points.push(newPoint);
                }
                this.drawings[this.drawings.length - 1].points.push(newPoint);
            }
        }
        this.drawMyPointer(x * 100, y * 100);
        if (Math.abs(this.prevMoves.x - x) >= 0.001 || Math.abs(this.prevMoves.y - y) >= 0.001) {
            this.prevMoves.x = x;
            this.prevMoves.y = y;
        }
        else {
            // it is an unnoticeable change
            return;
        }
        this.mouseEvents.push({ x: x, y: y, time: Date.now() });
    }
    addPointer(id, data, name) {
        this.pointerTracker += 1;
        this.pointers[id] = data;
        this.pointersName[id] = name;
    }
    async updatePointer(id, data) {
        var startedAt = Date.now();
        if (this.pointers[id] != undefined && this.pointers[id] != null) {
            const events = data;
            for (var i = 0; i < events.length; i++) {
                this.pointerTracker += 1;
                const event = events[i];
                const coords = event.split(",");
                this.pointers[id] = {
                    x: parseFloat(coords[0]) * 100,
                    y: parseFloat(coords[1]) * 100,
                    time: Date.now(),
                };
                this.drawPointers();
                if (Date.now() - startedAt + 25 > this.PT) {
                    break;
                }
                await this.sleep(this.PT / events.length);
            }
        }
    }
    deletePointer(id) {
        this.pointerTracker += 1;
        delete this.pointers[id];
        delete this.pointersMap[id];
    }
    sendMouseEventsEveryXSeconds(duration) {
        window.setTimeout(async () => {
            // send message to peer
            if (this.isPointersActive == true) {
                this.sendMouseEvents(this.mouseEvents);
            }
            // reset the mouseEvents queue
            this.mouseEvents = [];
            await this.sleep(this.MINIMUM_LATENCY); // Minimum latency  (D)
            this.sendMouseEventsEveryXSeconds(duration);
        }, duration);
    }
    sendMouseEvents(events) {
        // only send mouse events if there are new mouse events...
        if (this.mouseEvents.length == 0)
            return;
        const newEvents = ramerDouglasPeucker(events, 0.0001); // 95% reduction of events
        // console.log(newEvents.length / this.mouseEvents.length, "%", newEvents.length)
        const newEventsString = newEvents.map((e) => {
            return e.x.toFixed(3) + "," + e.y.toFixed(3);
        });
        this.drawings = this.drawings.filter((d) => {
            return d.points.length > 0;
        });
        const lowResDrawings = [];
        this.drawings.forEach((d) => {
            const points = ramerDouglasPeucker(d.points, 0.1); // it gives us a reduction of like 95% 
            // console.log(points.length/d.points.length, "%", points.length)
            lowResDrawings.push({ points: points, startedAt: d.startedAt });
        });
        CommandsManager_1.default.sendAllCommand('presenter--pointer_pos', { id: this.myId,
            positions: newEventsString,
            drawings: lowResDrawings,
        });
    }
}
exports.default = Pointers;
function ramerDouglasPeucker(points, epsilon) {
    // Find the point with the maximum distance from line between start and end
    const findMostDistantPoint = (points, start, end) => {
        let maxDistance = 0;
        let index = 0;
        for (let i = 1; i < points.length - 1; i++) {
            const distance = perpendicularDistance(points[i], start, end);
            if (distance > maxDistance) {
                maxDistance = distance;
                index = i;
            }
        }
        return { index, distance: maxDistance };
    };
    // Calculate the perpendicular distance from a point to a line
    const perpendicularDistance = (point, lineStart, lineEnd) => {
        let normalLength = Math.sqrt((lineEnd.x - lineStart.x) ** 2 + (lineEnd.y - lineStart.y) ** 2);
        return Math.abs((point.x - lineStart.x) * (lineEnd.y - lineStart.y) -
            (point.y - lineStart.y) * (lineEnd.x - lineStart.x)) / normalLength;
    };
    // Recursively simplify
    const douglasPeucker = (points, epsilon) => {
        if (points.length <= 2) {
            return points;
        }
        const { index, distance } = findMostDistantPoint(points, points[0], points[points.length - 1]);
        if (distance >= epsilon) {
            // Recursive call
            const leftSide = douglasPeucker(points.slice(0, index + 1), epsilon);
            const rightSide = douglasPeucker(points.slice(index), epsilon);
            // Combine results
            return leftSide.slice(0, -1).concat(rightSide);
        }
        else {
            return [points[0], points[points.length - 1]];
        }
    };
    return douglasPeucker(points, epsilon);
}
function getExponentialSmoothedPoint(lastPoint, newPoint, smoothingFactor) {
    return {
        time: newPoint.time,
        x: smoothingFactor * newPoint.x + (1 - smoothingFactor) * lastPoint.x,
        y: smoothingFactor * newPoint.y + (1 - smoothingFactor) * lastPoint.y
    };
}
